import { ColumnDef } from "@tanstack/react-table";
import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { Division, Person } from "../../../../types/types";
import { DataTable } from "../../../../ui/DataTable/DataTable";
import { Separator } from "../../../../ui/Separator";
import AddStaffDivision from "./AddStaffDivision";
import { SimpleDataTable } from "../../../../ui/DataTable/SimpleDataTable";

type Props = {
  id: string | undefined;
  currentDivision: Division;
};

type DivisionStaffTableData = {
  id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  access_token_id: string;
  leader: boolean;
};

const DivisionStaffTab = ({ id, currentDivision }: Props) => {
  const [persons, setPersons] = useState<Person[]>();

  let [isEditOpen, setIsEditOpen] = useState(false);
  let [isDeleteOpen, setIsDeleteOpen] = useState(false);
  let [currentItemId, setCurrentItemId] = useState("");

  function openEditModal() {
    setIsEditOpen(true);
  }

  function closeEditModal() {
    setIsEditOpen(false);
    setCurrentItemId("");
  }

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
    setCurrentItemId("");
  }

  const onItemEdit = (id: string) => {
    setCurrentItemId(id);
    openEditModal();
  };

  function onItemDelete(id: any): void {
    setCurrentItemId(id);
    openDeleteModal();
  }

  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/personnels?division_ids[]=${id}`);

  const refreshModels = () => {
    doFetchItem();
  };

  useEffect(() => {
    refreshModels();
  }, []);

  useEffect(() => {
    if (response) {
      const personsData = response.data as unknown as Person[];
      setPersons(personsData);
    }
  }, [response]);

  let nodes = persons?.map((data) => {
    return {
      id: data?.id,
      first_name: data.attributes.first_name,
      middle_name: data.attributes.middle_name,
      last_name: data.attributes.last_name,
      access_token_id: data.attributes.access_token_id,
      leader: data.attributes.leader,
    };
  });



  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const columns: ColumnDef<DivisionStaffTableData>[] = [
    {
      header: t("last_name"),
      size: 1000,
      maxSize: 1000,
      minSize: 1000,
      cell: ({ row }) => <div>{row.original.last_name}</div>,
    },
    {
      header: t("full_name"),
      size: 200,
      maxSize: 200,
      minSize: 200,
      cell: ({ row }) => <div>{row.original.first_name}</div>,
    },
    {
      header: t("card"),
      size: 100,
      maxSize: 100,
      minSize: 100,
      cell: ({ row }) => <div>{row.original.access_token_id}</div>,
    },
  ];

  return (
    <div className="flex flex-col w-full">
      <AddStaffDivision itemId={id} refreshModels={refreshModels} />
      <SimpleDataTable data={data.nodes} columns={columns} />
    </div>
  );
};

export default DivisionStaffTab;
